<template>
  <v-app>
    <component :is="myView" v-if="pauseBeforeRenderFlag"></component>
  </v-app>
</template>

<script>
import Licence from '@/views/licence'
import Mooring from '@/views/mooring'
import MooringFees from '@/views/mooring-fees'
import RecreationalFees from '@/views/recreational-fees'
import BoatingLicenceFees from '@/views/boating-licence-fees'
import Vessel from '@/views/vessel'
import Calculator from '@/views/calculator'

export default {
  data () {
    return {
      pauseBeforeRenderFlag: false
    }
  },
  props: ['myView'],
  components: {
    Licence,
    Mooring,
    MooringFees,
    RecreationalFees,
    BoatingLicenceFees,
    Vessel,
    Calculator
  },
  mounted () {
    window.setTimeout(() => {
      this.pauseBeforeRenderFlag = true
    }, 500)
  }
}
</script>

<style lang="scss">
@import './assets/_vuetify-scoped.scss';

#licence, #mooring, #vessel, #calculator, #mooring-fees, #recreational-fees, #boating-licence-fees {
  max-width: 800px;
  margin: auto;
  box-sizing: border-box;

  .application--wrap {
    background-color: #fff;
    height: auto;
    min-height: 0;
  }

  .captcha-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    margin: 20px 0;
  }

  /* Allow the usage of disabled inputs as labels */
  .input-group--disabled .input-group__details::before {
    display: none;
  }
  .theme--light .input-group--disabled .icon.icon--disabled,
  .theme--light .input-group--disabled label {
    color: rgba(0,0,0,0.54) !important;
  }

  .checker-results {
    font-family: 'Open Sans';
    font-size: 16px;
    display: flex;
    flex-wrap: wrap;
    color: #444;
  }

  .checker-results .half {
    flex: 0 0 50%;
    margin: 10px 0;
    padding: 0 20px;
  }

  .checker-results .full {
    flex: 0 0 100%;
    margin: 10px 0;
    padding: 0 20px;
  }

  .checker-results .gap {
    height: 1px;
    margin: 10px 0;
    background-color: #eee;
    flex: 0 0 100%;
  }

  .checker-results h3 {
    font-size: 1em;
    font-weight: 700;
  }

  .mast-header {
    background-size: contain;
    background-position: 0 100%;
    background-repeat: no-repeat;
    background-color: #1A3E6E;
    color: #fff;
    padding-bottom: 16%;
    font-family: 'Open Sans';
    font-weight: 600;
  }

  .date-flex {
    @media (min-width: 400px) {
      display: flex;
      > div {
        flex-basis: 33%;
      }
      > div + div {
        margin-left: 1rem;
      }
    }
  }

  .mooring-position {
    display: flex;
    flex-wrap: wrap;
  }
}
</style>



// WEBPACK FOOTER //
// src/app.vue